import type { PayloadAction } from '@reduxjs/toolkit';
import type { ModalPropTypes } from 'src/helper/shared-types';
import { MATERIAL_QUANTITY_TYPES } from 'src/views/VendorPortal/WorkOrder/constants';
import type { MaterialFormType } from 'src/views/VendorPortal/WorkOrder/types';
import type { ModalModeType, VendorModalsInitialStateType } from './types';

type PayloadType = {
  modalType: keyof VendorModalsInitialStateType;
  isVisible: boolean;
  extraProps?: ModalPropTypes;
};

const reducers = {
  toggleVendorModal: (state: VendorModalsInitialStateType, action: PayloadAction<PayloadType>) => {
    state[action.payload.modalType].isVisible = action.payload.isVisible;
    state[action.payload.modalType].extraProps = action.payload.extraProps;
  },

  // Material Modal
  addWorkOrderMaterial: (
    state: VendorModalsInitialStateType,
    action: PayloadAction<(type: ModalModeType, formData?: MaterialFormType) => void>,
  ) => {
    state.materialModal.isVisible = true;
    state.materialModal.extraProps = {
      data: {
        id: '',
        label: '',
        quantity: null,
        material_cost: null,
        cost_type: 'total',
        quantity_type: MATERIAL_QUANTITY_TYPES.units,
      },
      mode: 'add',
      onSuccess: action.payload,
    };
  },
  editWorkOrderMaterial: (
    state: VendorModalsInitialStateType,
    action: PayloadAction<{
      data: MaterialFormType;
      onSuccess: (type: ModalModeType, formData?: MaterialFormType) => void;
    }>,
  ) => {
    state.materialModal.isVisible = true;
    state.materialModal.extraProps = {
      data: action.payload.data,
      mode: 'edit',
      onSuccess: action.payload.onSuccess,
    };
  },
  openAllIssuesClosedModal: (state: VendorModalsInitialStateType) => {
    state.allIssuesClosedModal.isVisible = true;
  },
};

export default reducers;
